import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function QuestionSleepPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.v1.questionSleep.heading')}
      subheading={t('pages.onboarding.v1.questionSleep.subheading')}
      buttons={[
        {
          text: t('pages.onboarding.v1.questionSleep.button1'),
          value: '7-9_hours',
        },
        {
          text: t('pages.onboarding.v1.questionSleep.button2'),
          value: '5-7_hours',
        },
        {
          text: t('pages.onboarding.v1.questionSleep.button3'),
          value: 'less_than_5',
        },
        {
          text: t('pages.onboarding.v1.questionSleep.button4'),
          value: 'very_inconsistent',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
